<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de inconsistência">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    @exit="handleExit"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import Form from "@/components/atencao-basica/relatorio-inconsistencia/Form";

// Vuex.
import { mapActions } from 'vuex';

// Mixins
import { repository, error, object, data } from '@/mixins'

export default {
    components: { Form },
    created() {

        this.setShowExitFormConfirmation()

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.atencaoBasica')
        }
    },
    data: () => ({
        cadastro: false,
    }),
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation',
        ]),
        handleExit() {
            this.unsetShowExitFormConfirmation()
            this.$router.push({ name: 'dashboard' })
        },
    },
    mixins: [repository, error, object, data],
}
</script>